import type { Dispatch, SetStateAction } from 'react';
import type { FormSegment, GroupLike, LookalikeFormSegment } from '../../../../../types';
import { type DrawerState, type DrawerTypeValue, drawerType } from '../../../drawerTypes';
import type { UnifiedDrawerActionsProps } from '../hooks/types';
import { isLookalikeFormSegmentArray } from '../utils';

type SegmentSelectionProps = {
  allSelectedSegments?: FormSegment[] | LookalikeFormSegment[];
  directSegments?: FormSegment[];
  rtgSegments?: FormSegment[];
  thirdPartySegments?: FormSegment[];
  siteCategorySegments?: FormSegment[];
  oxPurchaseSegments?: FormSegment[];
};

type CreateDrawerActionsConfigParams = {
  currentDrawerType: DrawerTypeValue;
  drawerState: Extract<DrawerState, { isOpen: true }>;
  setDrawerState: Dispatch<SetStateAction<DrawerState>>;
  segmentsGroup: GroupLike;
  segmentSelectionProps: SegmentSelectionProps;
  hasSelectedItemsChanged: boolean;
  enforceMarketUnionAfterApply?: (fieldPath: string) => boolean;
};

export const createDrawerActionsConfig = ({
  currentDrawerType,
  drawerState,
  setDrawerState,
  segmentsGroup,
  segmentSelectionProps,
  hasSelectedItemsChanged,
  enforceMarketUnionAfterApply,
}: CreateDrawerActionsConfigParams): UnifiedDrawerActionsProps => {
  const baseConfig = {
    drawerState,
    setDrawerState,
    values: segmentsGroup,
    hasSelectedItemsChanged,
    enforceMarketUnionAfterApply,
  };

  if (
    currentDrawerType === drawerType.LOOKALIKE &&
    isLookalikeFormSegmentArray(segmentSelectionProps?.allSelectedSegments)
  ) {
    return {
      ...baseConfig,
      segments: {
        lookalike: segmentSelectionProps.allSelectedSegments,
      },
    };
  }

  return {
    ...baseConfig,
    segments: {
      direct: segmentSelectionProps.directSegments || [],
      rtg: segmentSelectionProps.rtgSegments || [],
      thirdParty: segmentSelectionProps.thirdPartySegments || [],
      siteCategory: segmentSelectionProps.siteCategorySegments || [],
      oxPurchase: segmentSelectionProps.oxPurchaseSegments || [],
    },
  };
};
